import Error400 from "../../components/common/Redirect/Error400";

const Error400Page = () => {
  return <Error400 />;
};

export default Error400Page;
